// What a list or page says when it has nothing: a rounded box with what is
// absent, a line on how it comes to exist (or how to recover), and the way
// to do it. components/EmptyState.jsx re-exports it beside the hooks that
// work out why a surface is empty.
export default function EmptyState({ title, note = null, action = null, className = "" }) {
    return (
        <div className={`grid gap-[4px] rounded-[10px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[10px] py-[12px] ${className}`.trim()}>
            <strong className="text-[13px] font-medium leading-[1.3] text-[color:var(--ink)]">{title}</strong>
            {note ? <span className="text-[12.5px] leading-[1.45] text-[color:var(--muted)] [overflow-wrap:anywhere]">{note}</span> : null}
            {action ? <div className="mt-[6px] flex">{action}</div> : null}
        </div>
    );
}
